import { render, staticRenderFns } from "./TheValueChartPanel.vue?vue&type=template&id=5d16d2e1&"
import script from "./TheValueChartPanel.vue?vue&type=script&lang=js&"
export * from "./TheValueChartPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports